export class Auth {
  constructor() {
    this.store = null;
    this.router = null;
    this.userInfoFetched = false;
  }

  isLogged() {
    return this.store ? this.store.getters.loggedIn : false;
  }
  currentUser() {
    return this.store ? this.store.getters.user : null;
  }
}

const instance = new Auth();
function authHelper(Vue, options) {
  if (options.router && options.store) {
    if (options.store.getters.loggedIn) {
      const accessToken = options.store.state.auth.accessToken;
      options.store.$axios.setHeader('Authorization', `Token ${accessToken}`);
    }

    instance.router = options.router;
    instance.store = options.store;

    const router = options.router;
    router.beforeEach((to, from, next) => {
      if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
        if (middleware.includes('auth')) {
          if (options.store.getters.loggedIn) {
            if (!instance.userInfoFetched) {
              instance.store.dispatch('auth.updateUser');
              instance.userInfoFetched = true;
            }
          } else {
            return router.push({ name: 'login' });
          }
        }
      }
      next();
    });
  }
  Object.defineProperties(Vue.config.globalProperties, {
    $auth: {
      get() {
        return instance;
      },
    },
  });
}

export default authHelper;
